import { AnimatePresence, motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import image1 from '../../../assets/template/driver_f1.jpeg';
import image2 from '../../../assets/template/doctor.jpeg';
import image3 from '../../../assets/template/pilot.jpeg';
import image4 from '../../../assets/template/police.jpeg';
import image5 from '../../../assets/template/musician.jpeg';

const dreams = [
  {
    title: '',
    image: image1
  },
  {
    title: '',
    image: image2
  },
  {
    title: '',
    image: image3
  },
  {
    title: '',
    image: image4
  },
  {
    title: '',
    image: image5
  }
];

export default function DreamPreviewCarousel() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % dreams.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="mt-10">
      <div className="relative mx-auto w-[220px]">
        {/* Back Card */}
        <motion.div
          animate={{
            rotate: -8,
            scale: 0.92
          }}
          className="absolute top-4 left-[-18px] aspect-[9/16] w-full rounded-[32px] bg-violet-500/10"
        />

        {/* Middle Card */}
        <motion.div
          animate={{
            rotate: 8,
            scale: 0.92
          }}
          className="absolute top-4 right-[-18px] aspect-[9/16] w-full rounded-[32px] bg-cyan-500/10"
        />

        {/* Main Card */}
        <AnimatePresence mode="wait">
          <motion.div
            key={current}
            initial={{
              opacity: 0,
              scale: 0.96,
              y: 20
            }}
            animate={{
              opacity: 1,
              scale: 1,
              y: 0
            }}
            exit={{
              opacity: 0,
              scale: 0.96,
              y: -20
            }}
            transition={{
              duration: 0.45
            }}
            className="relative overflow-hidden rounded-[32px] border border-white/10 shadow-2xl">
            <img
              src={dreams[current].image}
              alt={dreams[current].title}
              className="aspect-[9/16] w-full object-cover"
            />

            {/* <div className="absolute inset-0 bg-gradient-to-t from-black via-black/20 to-transparent" />

            <div className="absolute bottom-0 left-0 w-full p-5">
              <div className="mb-2 text-[10px] font-bold uppercase tracking-[0.3em] text-violet-300">
                Dream Preview
              </div>

              <h3 className="text-2xl font-black">
                {dreams[current].title}
              </h3>
            </div> */}
          </motion.div>
        </AnimatePresence>
      </div>

      {/* Indicators */}
      <div className="mt-6 flex justify-center gap-2">
        {dreams.map((_, index) => (
          <div
            key={index}
            className={`h-2 rounded-full transition-all duration-300 ${
              index === current ? 'w-8 bg-violet-400' : 'w-2 bg-white/20'
            }`}
          />
        ))}
      </div>

      {/* <p className="mt-4 text-center text-sm text-zinc-400">
        Hasil akan berbeda sesuai pilihan mimpimu
      </p> */}
    </div>
  );
}
